import Raven from 'raven-js';
import http from 'hub-http/clients/apiClient';
import { onFetchContentSchemaSuccess, onFetchContentSchemaFailed
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { getContentTypeName } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import { standardFetchCustomModules, fetchModuleSchemasFailed, fetchModuleSchemasSucceeded
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/moduleSchemaActions';
import { fetchTableAsModuleSchema, fetchInstanceData, fetchContentTypeSchema, setContentTypeMeta, fetchInstanceGroupData } from 'structured-content-lib/redux/actions/instanceEditActions';
import { selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { fetchContentSchema, fetchGlobalModules } from './editorClient';
import { CONTENT_TYPE_TABLE_NAME, GROUPS_API_URL } from '../constants';
import { fetchInstance } from '../api';
const contentTypeName = 'hs_case_study';
function fetchGroup(groupId) {
  return http.get(`${GROUPS_API_URL}/${groupId}`);
}
export const initialRequestActions = () => (dispatch, getState) => {
  const contentPromise = fetchContentSchema().then(async result => {
    const state = getState();
    const instanceLayoutPage = await result;
    /** @TODO Use dynamicPageDataSourceId when all instances are backfilled. */
    // const tableName = instanceLayoutPage.content.dynamicPageDataSourceId;
    const tableName = CONTENT_TYPE_TABLE_NAME;
    const instanceId = selectActiveHubDbRowId(state);
    dispatch(setContentTypeMeta(contentTypeName, tableName));
    await dispatch(onFetchContentSchemaSuccess({
      result
    }));
    await dispatch(fetchTableAsModuleSchema(tableName));
    await dispatch(fetchInstanceData(tableName, () => fetchInstance(instanceId)));
    await dispatch(fetchInstanceGroupData(() => fetchGroup(instanceLayoutPage.content.contentGroupId)));
    await dispatch(fetchContentTypeSchema(contentTypeName, tableName));
    return instanceLayoutPage;
  }, result => dispatch(onFetchContentSchemaFailed({
    result
  })));
  const globalPromise = fetchGlobalModules().then(response => ({
    response
  }), error => ({
    error
  }));
  const customModulePromise = dispatch(standardFetchCustomModules());
  return Promise.all([globalPromise, customModulePromise, contentPromise]).then(requests => {
    const [globalModules = {}, customModules = {}] = requests;
    const categoryName = getContentTypeName(getState());

    // Need to check for errors again, because we already dispatch the failure action for each
    // of the sub-requests, which turns it into a resolved promise again
    for (const request of requests) {
      if (!request) {
        Raven.captureMessage('request is not defined ', {
          extra: {
            requests
          }
        });
      }
      if (request && request.error) {
        return dispatch(fetchModuleSchemasFailed(request));
      }
    }
    return dispatch(fetchModuleSchemasSucceeded({
      categoryName,
      globalModules: globalModules.response,
      customModules: customModules.response
    }, {
      fromSuperStoreCache: customModules.fromSuperStoreCache
    }));
  });
};